
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell, Search, Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import UserMenu from './UserMenu';
import { useIsMobile } from '@/hooks/use-mobile';

interface HeaderButtonsProps {
  user: any;
  onLogout: () => void;
  isMenuOpen: boolean;
  toggleMenu: () => void;
}

const HeaderButtons: React.FC<HeaderButtonsProps> = ({
  user,
  onLogout,
  isMenuOpen,
  toggleMenu
}) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  return (
    <div className="flex items-center gap-2">
      {!isMobile && (
        <>
          <Button variant="glass" size="icon" className="text-white hover:text-neon-purple hover:border-neon-purple/30 transition-all duration-300">
            <Bell className="h-5 w-5" />
          </Button>
          <Button variant="glass" size="icon" className="text-white hover:text-neon-blue hover:border-neon-blue/30 transition-all duration-300">
            <Search className="h-5 w-5" />
          </Button>
        </>
      )}
      
      {user ? (
        <UserMenu
          userImageUrl={user.user_metadata?.avatar_url}
          userFirstName={user.user_metadata?.first_name || user.email?.charAt(0)}
          userLastName={user.user_metadata?.last_name}
          fullName={user.user_metadata?.full_name || user.email}
          onLogout={onLogout}
        />
      ) : (
        <Button 
          variant="outline" 
          size="sm" 
          className="ml-2" 
          onClick={() => navigate('/auth/signin')}
        >
          Sign In
        </Button>
      )}
      
      {isMobile && (
        <Button
          variant="ghost"
          size="icon"
          onClick={toggleMenu}
          className="md:hidden"
        >
          {isMenuOpen ? (
            <X className="h-5 w-5" />
          ) : (
            <Menu className="h-5 w-5" />
          )}
        </Button>
      )}
    </div>
  );
};

export default HeaderButtons;
